export default __webpack_public_path__ + "static/media/WhatsApp Image 2022-04-13 at 6.27.28 PM@2x.9261624d.png";